exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".customCard[data-v-7f9a987b]{width:347px;height:221px;border-radius:10px;display:inline-block;position:relative;border:1px dotted #ccc}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-7f9a987b","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/cardDesign/CardDesign.vue
// module id = 410
// module chunks = 0